import gql from 'graphql-tag';

export const createTransactionMutation = () => gql`
  mutation createManualTransaction($orgId: ID!, $sourceId: ID!, $txn: TxnCreateTransaction!) {
    createManualTransaction(orgId: $orgId, sourceId: $sourceId, txn: $txn) {
      id
    }
  }
`;
